import { render, staticRenderFns } from "./TopicA.vue?vue&type=template&id=040a05ae"
import script from "./TopicA.vue?vue&type=script&lang=js"
export * from "./TopicA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports